// @flow
import React from 'react';
import { Container, Row, Col } from 'Components/Grid';
import styles from './styles.scss';
import classNames from 'classnames/bind';
import Typography from 'Components/Typography';

const cx = classNames.bind(styles);

type Props = {
  headline?: string,
  children: Node,
  fixed?: Boolean,
};

export class ImageBoxContainer extends React.Component<Props> {
  render() {
    const { headline, children, fixed } = this.props;
    const containerClass = cx('container', {
      moreThanThree: children.length > 3,
      fixed,
    });

    return (
      <Container>
        <Row>
          <Col>
            {headline && (
              <Typography.Headline
                className={styles.headline}
                level="h2"
                forceUppercase={true}
                value={headline}
              />
            )}
            <ul className={containerClass}>{children}</ul>
          </Col>
        </Row>
      </Container>
    );
  }
}
